import { X } from 'lucide-react';

export default function Modal({ title, onClose, children }) {
  return (
    <div 
      className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm" 
      onClick={onClose}
      data-testid="modal-overlay"
    >
      <div 
        className="w-full max-w-lg bg-[#131926] border border-[#1E2D45] rounded-xl shadow-2xl" 
        onClick={e => e.stopPropagation()}
        data-testid="modal-content"
      >
        <div className="flex items-center justify-between p-4 border-b border-[#1E2D45]">
          <h2 className="text-base font-bold font-syne text-[#E2E8F0]">{title}</h2>
          <button 
            onClick={onClose} 
            className="text-[#4A5568] hover:text-[#E2E8F0] transition-colors"
            data-testid="modal-close-btn"
          >
            <X size={18} />
          </button>
        </div>
        <div className="p-4">{children}</div>
      </div>
    </div>
  );
}
